import {computed, ref} from 'vue';
import {defineStore} from 'pinia';
import {USER_FIELDS} from "@/utilities/enums";
import {EndpointsFactory} from "../utilities/endpoints.js";
import {DecodeResponseType, WorkerResponseCode} from "../utilities/workerUtilites.js";
import {URLS_FACTORY} from "@/router/urls.js";
import {useDomStore} from "@/stores/dom.js";
import {useUsersStore} from "@/stores/users.js";

export const useUserStore = defineStore('user', () => {
  const currentUser = ref(null);
  const globalsConfig = ref(null);
  const isLoggedIn = computed(() => !!currentUser.value);
  const fullName = computed(() => !currentUser.value ? '' : currentUser.value[USER_FIELDS.name] + " " + currentUser.value[USER_FIELDS.surname]);
  const initials = computed(() => {
    if(!currentUser.value){
      return '';
    }
    return currentUser.value[USER_FIELDS.name].substring(0, 1) + currentUser.value[USER_FIELDS.surname].substring(0, 1);
  });
  const currentToken = computed(() => currentUser?.value?.[USER_FIELDS.token]);
  const notificationToken = ref('');

  function setUser(userData){
    currentUser.value = userData;
  }

  function logout(tokenIsExpired = false){
    return new Promise(resolve => {
      const $router = this.router;
      const onEnd = () => {
        currentUser.value = null;
        useDomStore().reset();
        useUsersStore().reset();
        $router.push(URLS_FACTORY.URLS_PATHS.ROOT).then(resolve)
      };

      if(tokenIsExpired || !currentUser.value){
        onEnd();
        return;
      }
      EndpointsFactory.execApiViaWorker({
        url: EndpointsFactory.getEndpoint(EndpointsFactory.ENDPOINTS.LOGOUT, {user_id: currentUser.value[USER_FIELDS.id]}),
        method: 'DELETE',
        token: currentToken.value,
        body: JSON.stringify({user_id: currentUser.value[USER_FIELDS.id]}),
        decodeResponseType: DecodeResponseType.NOTHING
      }, WorkerResponseCode.LOGOUT, onEnd, onEnd, true);
    });
  }

  function updateUser(userData){
    currentUser.value = userData;
  }

  function setNotificationToken(token){
    notificationToken.value = token;
  }

  function setGlobalsConfig(config){
    globalsConfig.value = config;
  }

  return {
    currentUser,
    currentToken, notificationToken,
    globalsConfig,
    isLoggedIn,
    setUser,
    logout,
    fullName,
    initials,
    updateUser,
    setNotificationToken,
    setGlobalsConfig
  }
}, {
  persist: true
});
